import { LineChart as GenericChart } from './line-chart';
import type { ChartProps } from './types';

export function LineChart(props: ChartProps) {
  return (
    <GenericChart
      {...props}
      style={{
        fill: false,
        secondary: {
          col: '#00e296',
          dashWidth: 10,
        },
        primary: {
          col: '#0390fb',
        },
        strokeWidth: 4,
      }}
    />
  );
}
